import { render, staticRenderFns } from "./ViqChatPanel.vue?vue&type=template&id=157cc18c&scoped=true"
import script from "./ViqChatPanel.vue?vue&type=script&lang=js"
export * from "./ViqChatPanel.vue?vue&type=script&lang=js"
import style0 from "./ViqChatPanel.vue?vue&type=style&index=0&id=157cc18c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157cc18c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157cc18c')) {
      api.createRecord('157cc18c', component.options)
    } else {
      api.reload('157cc18c', component.options)
    }
    module.hot.accept("./ViqChatPanel.vue?vue&type=template&id=157cc18c&scoped=true", function () {
      api.rerender('157cc18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqChatPanel.vue"
export default component.exports